import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { SellCoinPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/sell-coin/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<SellCoinPage />
		</DashboardLayout>
	);
}
